import * as React from 'react';
import {inject, observer} from 'mobx-react';
import Helmet from 'react-helmet';
import Layout, {Main} from '../../components/Layout';
import Card, {CardHeader, CardBody} from '../../components/Card';

import {Form, Input, Button, Select, Alert} from 'antd';
import {Checkbox} from 'antd';
import './main.css';
import {MailingListType} from '../../models/MailingListModel';
import {AlertProps} from 'antd/lib/alert';
import {CheckboxChangeEvent} from 'antd/lib/checkbox';

const Option = Select.Option;

interface MailingListState {
  isAlert: boolean;
  isError: boolean;
  isCreating: boolean;

  handleName: string;
  name: string;
  description?: string;
  botIncluded?: boolean;
  accessLevel: string;
}

interface WithInjectedProps {
  mailingList: MailingListType;
}

@inject('mailingList')
@observer
class MaillingList extends React.Component<{}, MailingListState> {
  public constructor(props: {}) {
    super(props);
    this.state = {
      isError: false,
      isAlert: false,
      isCreating: false,

      handleName: '',
      name: '',
      description: '',
      botIncluded: true,
      accessLevel: 'everyone'
    };
  }
  public render() {
    const formItemLayout = {
      labelCol: {
        xs: {span: 10},
        sm: {span: 8}
      },
      wrapperCol: {
        xs: {span: 10},
        sm: {span: 16}
      }
    };

    return (
      <React.Fragment>
        <Helmet>
          <title>Mailing List</title>
        </Helmet>
        <Layout>
          <Main>
            <Card>
              <CardHeader>
                <p>Create mailing list</p>
              </CardHeader>
              <CardBody>
                {this.state.isAlert ? this.alert() : ''}

                <Form layout="horizontal">
                  <Form.Item
                    {...formItemLayout}
                    label="Alias Address"
                    required={true}
                  >
                    <Input
                      value={this.state.handleName}
                      type="text"
                      addonAfter="@ai.cohost.club"
                      onChange={this.onChangeHandleName}
                    />
                  </Form.Item>
                  <Form.Item {...formItemLayout} label="Name" required={true}>
                    <Input
                      type="text"
                      value={this.state.name}
                      onChange={this.onChangeName}
                    />
                  </Form.Item>
                  <Form.Item {...formItemLayout} label="Description">
                    <Input
                      type="text"
                      value={this.state.description}
                      onChange={this.onChangeDescription}
                    />
                  </Form.Item>
                  <Form.Item {...formItemLayout} label="Access level">
                    <Select
                      defaultValue="everyone"
                      onChange={this.onChangAccessLevel}
                    >
                      <Option value="everyone">Everyone</Option>
                      <Option value="members">Members</Option>
                      <Option value="readonly">Read Only</Option>
                    </Select>
                  </Form.Item>
                  <Form.Item {...formItemLayout} label="Bot Included">
                    <Checkbox
                      checked={this.state.botIncluded}
                      onChange={this.onChangBotIncluded}
                    >
                      bot@m.cohost.club
                    </Checkbox>
                  </Form.Item>

                  <Button
                    type="primary"
                    className="ch-btn-create"
                    onClick={this.onCreateMailingList}
                    loading={this.state.isCreating}
                  >
                    Create
                  </Button>
                </Form>
              </CardBody>
            </Card>
          </Main>
        </Layout>
      </React.Fragment>
    );
  }
  normalizeHandleName = (handleName: string) => {
    return handleName.replace(/ /g, '').toLowerCase();
  };

  onChangeHandleName = (event: React.ChangeEvent<HTMLInputElement>) => {
    let handleName = event.target.value;
    handleName = this.normalizeHandleName(handleName);
    this.setState({handleName});
  };

  onChangeName = (event: React.ChangeEvent<HTMLInputElement>) => {
    let name = event.target.value;
    this.setState({name});
  };
  onChangeDescription = (event: React.ChangeEvent<HTMLInputElement>) => {
    let description = event.target.value;
    this.setState({description});
  };
  onChangBotIncluded = (event: CheckboxChangeEvent) => {
    let botIncluded = event.target.checked;
    this.setState({botIncluded});
  };
  onChangAccessLevel = (accessLevel: string) => {
    this.setState({accessLevel});
  };
  onCreateMailingList = () => {
    this.setState({isCreating: true});
    this.withInjectedProps.mailingList.createMailingList(
      this.state,
      this.notify
    );
  };

  alert = () => {
    let message = 'Create mailing list successfully';
    let typeAlert: string = 'success';

    if (this.state.isError) {
      message = 'Create mailing list failed';
      typeAlert = 'error';
    }

    const alertProps = {
      message,
      type: typeAlert
    } as AlertProps;

    return <Alert {...alertProps} closable={true} showIcon={true} />;
  };

  notify = (status: Number) => {
    if (status === 200) {
      this.setState({isAlert: true, isError: false});
    } else {
      this.setState({isAlert: true, isError: true});
    }
    this.setState({isCreating: false});
  };
  get withInjectedProps() {
    return this.props as WithInjectedProps;
  }
}

export default MaillingList;



// WEBPACK FOOTER //
// ./src/pages/MailingList/MailingList.tsx